import mendeleev from "@/urls/mendeleev"
import {
  sendGetRequest, sendPostRequestFile,
} from "@/helper/requests"

const state = {
  feedbacks: {
    currentUrl: null,
    items: [],
    loading: false,
    loadingDetail: false,
    count: 0,
    detail: [],
    next: null,
    prev: null,
    error: null,
  }
}

const getters = {
  getFeedbacks: state => state.feedbacks.items,
  getFeedbacksCount: state => state.feedbacks.count,
  getFeedbacksCurrentUrl: state => state.feedbacks.currentUrl,
  getFeedbacksNext: state => state.feedbacks.next,
  getFeedbacksPrev: state => state.feedbacks.prev,
  getFeedbackDetail: state => state.feedbacks.detail,
  isLoadingFeedbacks: state => state.feedbacks.loading,
  isLoadingFeedbackDetail: state => state.feedbacks.loadingDetail,
  saveFeedbacksError: state => state.feedbacks.error,
}

const actions = {
  loadFeedbacks: ({ commit, getters }, { url, urlAppend, finalizer = () => {}, catcher = () => {} }) => {
    if (!url) {
      url = mendeleev.USER.FEEDBACKS.LIST()
      if (urlAppend) url = urlAppend(url)
    }
    if (!getters.isLoadingFeedbacks) {
      commit('SET_FEEDBACKS_LOADING')
      sendGetRequest(
        url, (data, url) => {
          commit('SET_FEEDBACKS', data.results)
          commit('SET_FEEDBACKS_COUNT', data.count)
          commit('SET_FEEDBACKS_CURRENT_URL', url)
          commit('SET_FEEDBACKS_NEXT_URL', data.next)
          commit('SET_FEEDBACKS_LOADING_END')
          finalizer(data, url)
        }, (data, url) => {
          commit('SET_FEEDBACKS_LOADING_END')
          commit('SAVE_FEEDBACKS_ERROR', data)
          catcher(data, url)
        }
      )
    }
  },
  createFeedback: ({ commit }, { data, finalizer = () => {}, catcher = () => {} }) => {
    const url = mendeleev.USER.FEEDBACKS.CREATE()
    sendPostRequestFile(
      url, data, (data, url) => {
        finalizer(data, url)
      }, (data, url) => {
        catcher(data, url)
      }
    )
  },
  loadFeedbackDetail: ({ commit }, { id, finalizer = () => {}, catcher = () => {} }) => {
    const url = mendeleev.USER.FEEDBACKS.DETAIL(id)
    // if (!getters.isLoadingFeedbackDetail) {
    commit('SET_FEEDBACK_DETAIL_LOADING')
    sendGetRequest(
      url, (data, url) => {
        commit('SET_FEEDBACKS_DETAIL', data)
        commit('SET_FEEDBACK_DETAIL_LOADING_END')
        finalizer(data, url)
      }, (data, url) => {
        commit('SAVE_FEEDBACKS_ERROR', data)
        commit('SET_FEEDBACK_DETAIL_LOADING_END')
        catcher(data, url)
      }
    )
    // }
  },
}

const mutations = {
  SET_FEEDBACKS: (state, value) => {
    state.feedbacks.items = value
  },
  SET_FEEDBACKS_DETAIL: (state, value) => {
    state.feedbacks.detail = value
  },
  SET_FEEDBACKS_COUNT: (state, value) => {
    state.feedbacks.count = value
  },
  SET_FEEDBACKS_CURRENT_URL: (state, value) => {
    state.feedbacks.currentUrl = value
  },
  SET_FEEDBACKS_NEXT_URL: (state, value) => {
    state.feedbacks.next = value
  },
  SET_FEEDBACKS_PREV_URL: (state, value) => {
    state.feedbacks.prev = value
  },
  SET_FEEDBACKS_LOADING: (state) => {
    state.feedbacks.loading = true
  },
  SET_FEEDBACKS_LOADING_END: (state) => {
    state.feedbacks.loading = false
  },
  SET_FEEDBACK_DETAIL_LOADING: (state) => {
    state.feedbacks.loadingDetail = true
  },
  SET_FEEDBACK_DETAIL_LOADING_END: (state) => {
    state.feedbacks.loadingDetail = false
  },
  SAVE_FEEDBACKS_ERROR: (state, error) => {
    state.feedbacks.error = error
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
